import { id } from "date-fns/locale";

const TmpPE020 = (page, section) => {
  const materials = [];
  const modifiedPage = {
    ...page
  };

  const snippet = {
    content: {
      core: page.content.core,
    },
    page: page.id,
    section: section,
    type: 'snippet'
  };

  materials.push(snippet);
  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: materials || [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE020;
